import {normalize} from './../../util/utils';
import * as types from '../../actions/actiontypes';
import {getAuditPlanAccounts} from '../../util/Ares/auditPlanSummaryState';

export default function reducer(state = {}, action) {
	switch (action.type) {
		case types.GET_ACCOUNTS:
			if (action.response && action.response.data && !action.isManageAccounts) {
				const _assertions = action.response.data
					.flatMap((account) => account.assertions || [])
					.map((assertion) => ({
						...assertion,
						risks: assertion.risks?.map((risk) => risk.id)
					}));
				const newState = action.mergeStrategy ? normalize(_assertions, undefined, state, action.mergeStrategy) : normalize(_assertions);
				return newState;
			}
			return state;
		// Audit plan summary bodies (356, 357) read assertions from this slice, and their accounts arrive
		// one page at a time, so their responses always merge instead of replacing.
		case types.LIST_AUDIT_PLAN_ACCOUNTS:
		case types.GET_AUDIT_PLAN_ACCOUNT_BY_ID: {
			const accounts = getAuditPlanAccounts(action);
			if (!accounts.length) return state;

			const _assertions = accounts
				.flatMap((account) => account.assertions || [])
				.map((assertion) => ({
					...assertion,
					risks: assertion.risks?.map((risk) => risk.id)
				}));
			return normalize(_assertions, undefined, state, action.mergeStrategy || undefined);
		}
		default:
			return state;
	}
}
